import Plans from './index'
import BranchInvoices from "./BranchPlan/Invoices"
import BranchPlan from "./BranchPlan"

export const paths = [
    {
        path: "/plans",
        component: BranchPlan
    },
    {
        path: "/plans/select",
        component: Plans
    },
    {
        path: "/plan/branch-invoices",
        component: BranchInvoices
    }
]


// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/routers.js